export const toUSCurrency = (value: number, decimals: number = 2): string =>  {
    return Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: decimals}).format(value);
};

export const toPercentage = (value: number, decimals: number = 0): string =>  {
    return Intl.NumberFormat('en-US', {style: 'percent', minimumFractionDigits: decimals}).format(value);
};

export const getLastNumber = (numStr: string): number => {
    const lastNumber = numStr.match(/(\d+)(?!.*\d)/);
    if (lastNumber && lastNumber.length) {
        return parseInt(lastNumber[0], 10);
    }
    return -1;
};



// WEBPACK FOOTER //
// ./src/utils/numberUtils.tsx